import { money } from "@/lib/api";
import { roomLabel } from "@/components/experience/BudgetCalculator";

export const CardNumbers = ({ exp }) => (
  <div className="grid grid-cols-3 gap-2 rounded-[10px] border border-border p-3 text-center" data-testid={`card-numbers-${exp.id}`}>
    <div><p className="text-[11px] uppercase tracking-[0.14em] text-muted-foreground">Per co-host</p><p className="font-semibold text-primary">{exp.share_per_cohost ? money(exp.share_per_cohost, exp.currency) : "TBC"}</p></div>
    <div><p className="text-[11px] uppercase tracking-[0.14em] text-muted-foreground">Co-hosts</p><p className="font-semibold">{exp.cohost_count}/{exp.cohost_slots}</p></div>
    <div><p className="text-[11px] uppercase tracking-[0.14em] text-muted-foreground">Guests</p><p className="font-semibold">{exp.guest_count}/{exp.guest_places}</p></div>
  </div>
);

const Stat = ({ label, value, accent }) => (
  <div className="rounded-[12px] border border-border p-4">
    <p className="text-xs uppercase tracking-[0.16em] text-muted-foreground">{label}</p>
    <p className={accent ? "mt-1 font-display text-3xl text-primary" : "mt-1 font-display text-2xl"}>{value}</p>
  </div>
);

export const DetailNumbers = ({ exp }) => (
  <section className="mt-10" aria-label="Budget and places" data-testid="detail-numbers">
    <p className="eyebrow">The numbers</p>
    <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
      <Stat label="Total budget" value={exp.budget_total ? money(exp.budget_total, exp.currency) : "TBC"} />
      <Stat accent label={exp.split_mode === "equal" ? "Each co-host" : "Avg per co-host"} value={exp.share_per_cohost ? money(exp.share_per_cohost, exp.currency) : "TBC"} />
      <Stat label="Co-host places" value={`${exp.cohost_count} of ${exp.cohost_slots}`} />
      <Stat label="Guest places" value={`${exp.guest_count} of ${exp.guest_places}`} />
    </div>
    {(exp.venue || exp.bedrooms) && <p className="mt-4 text-sm text-muted-foreground">{[exp.venue, exp.bedrooms ? `${exp.bedrooms} ${roomLabel(exp.type).toLowerCase()}` : ""].filter(Boolean).join(" · ")}</p>}
    {exp.cost_items?.length > 0 && (
      <ul className="mt-4 divide-y divide-border rounded-[12px] border border-border" data-testid="detail-cost-items">
        {exp.cost_items.map((it, i) => <li key={i} className="flex justify-between gap-4 px-4 py-3 text-sm"><span>{it.label}</span><span className="font-semibold">{money(it.amount, exp.currency)}</span></li>)}
      </ul>
    )}
  </section>
);
